import SetupData from "../data/setupData"

export const thousandSeparator = nStr => {
    return nStr.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export const formatDate = dateString => {
    const date = new Date(dateString)

    // Define the months in abbreviated form
    const monthNames = SetupData.monthNames

    // Get the day, month, and year from the Date object
    const day = date.getDate()
    const monthIndex = date.getMonth()
    const year = date.getFullYear()

    // Create the formatted date string in the desired format
    const formattedDate = `${monthNames[monthIndex]} ${day}, ${year}`
    return formattedDate
}

export const formatDateNumber = dateString => {
    const dateObj = new Date(dateString);

    const options = { day: "2-digit", month: "2-digit", year: "numeric" };
    const formattedDate = dateObj.toLocaleDateString("en-US", options);

    // Split the date parts and rearrange them
    const dateParts = formattedDate.split('/');
    const formattedDateDDMMYYYY = `${dateParts[1]}/${dateParts[0]}/${dateParts[2]}`;

    return formattedDateDDMMYYYY;
}

export const getPreviousMonth = () => {
    // Create a new Date object for the current date
    const currentDate = new Date();

    // Subtract one month to get the previous month
    currentDate.setMonth(currentDate.getMonth() - 1);

    // Get the month name and year in the desired format
    const monthNames = SetupData.monthNames
    const month = monthNames[currentDate.getMonth()];
    const year = currentDate.getFullYear();

    // Display the result
    return month + " " + year;
}

export const getTotal = (object) => {
    return object.reduce((acc, curr) => acc + curr.totalCommission, 0)
}

export const getHighest = (object) => {
    return object.reduce((prev, current) => {
        return (prev.totalCommission > current.totalCommission) ? prev : current
    })
}

export const getHighestGroup = (object) => {
    const flattenedGroups = object.flatMap(branch => branch.group)

    return flattenedGroups.reduce((prev, current) => {
        return (prev.totalCommission > current.totalCommission) ? prev : current
    })
}


// TEMPORARY FUNCTION
export const sanitizeBranch = (data) => {
    const branches = {};
    const combinedData = [];

    for (const item of data) {
        const branch = item.CommissionPayToUserBranch;

        // Check if the branch exists in branches
        if (!branches[branch]) {
            if (!branch) break

            branches[branch] = {
                branch: branch,
                agent: []
            };

            combinedData.push(branches[branch]);
        }

        const branchData = branches[branch];
        if (branchData.agent.length < 10) {
            branchData.agent.push(item);
        }
    }

    return combinedData;
}

export const sanitizeGroup = (data) => {
    const groups = {};
    const combinedData = [];

    for (const item of data) {
        const branch = item.CommissionPayToUserBranch;
        const group = item.CommissionPayToUserGroupName;

        // Check if the group exists in groups
        if (!groups[group]) {
            if (!group) break

            groups[group] = {
                branch: branch,
                group: group,
                agent: []
            };

            combinedData.push(groups[group]);
        }

        const branchData = groups[group];
        if (branchData.agent.length < 10) {
            branchData.agent.push(item);
        }
    }

    return combinedData;
}